/* Keep the reviewed vendor runtime unchanged; bind this fix before it initializes products. */
(function() {
  var theme = window.theme = window.theme || {};
  var availability;
  Object.defineProperty(theme, 'StoreAvailability', {
    configurable: true,
    enumerable: true,
    get: function() { return availability; },
    set: function(Constructor) {
      Constructor.prototype.updateContent = function(variantId) {
        var self = this;
        var basePath = new URL(this.baseUrl || '/', window.location.origin).pathname.replace(/\/+$/, '');
        return fetch(basePath + '/variants/' + variantId + '/?section_id=store-availability')
          .then(function(response) { return response.text(); })
          .then(function(html) {
            if (html.trim() === '') {
              self.container.innerHTML = '';
              return;
            }
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
            if (self.container.querySelector('.js-drawer-open-availability')) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }
            if (self.container.querySelector('.js-modal-open-availability')) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }
            var title = self.container.querySelector('[data-availability-product-title]');
            if (title) title.textContent = self.productTitle;
          });
      };
      availability = Constructor;
    }
  });
})();
